/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  MarketplaceSettingsResult,
  MarketplaceSettingsResult$inboundSchema,
} from "./marketplacesettingsresult.js";

export type UpdateMarketplaceSettingsResult = {
  /**
   * True when the new name reached the MCP plugins and marketplace manifests but the observability (hooks) plugin could not be updated yet because the organization is not approved for the latest hooks version; it will update automatically once the organization is rolled forward.
   */
  hooksUpdateDeferred?: boolean | undefined;
  /**
   * Whether the marketplace was automatically republished to GitHub as part of this update.
   */
  republished: boolean;
  settings: MarketplaceSettingsResult;
};

/** @internal */
export const UpdateMarketplaceSettingsResult$inboundSchema: z.ZodMiniType<
  UpdateMarketplaceSettingsResult,
  unknown
> = z.pipe(
  z.object({
    hooks_update_deferred: z.optional(z.boolean()),
    republished: z.boolean(),
    settings: MarketplaceSettingsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "hooks_update_deferred": "hooksUpdateDeferred",
    });
  }),
);

export function updateMarketplaceSettingsResultFromJSON(
  jsonString: string,
): SafeParseResult<UpdateMarketplaceSettingsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateMarketplaceSettingsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateMarketplaceSettingsResult' from JSON`,
  );
}
